import { Button, Icon } from "@components";
import { ChatMessageType } from "@utilities/types";
import { FC } from "react";

interface Props {
    message: ChatMessageType;
    onRetry: () => void;
    bymESource: string;
}

export const MessageBubble: FC<Props> = ({ message, onRetry, bymESource }) => (
    <div
        className={`chat ${message.sender === 'user'
            ? 'chat-end'
            : 'chat-start'}`
        }
    >
        {
            message.sender !== 'user' && (
                <div className="chat-image avatar">
                    <div className="w-10 rounded-full">
                        <img
                            alt="Chat Avatar"
                            src={bymESource}
                        />
                    </div>
                </div>
            )
        }

        <div
            className={`chat-bubble 
                ${message.sender !== 'user' ? '': 'chat-bubble-secondary'} 
                ${message.status === 'error' ? 'bg-error/10 text-error' : ''}`
            }
        >
            <div 
                className="text-xs"
                dangerouslySetInnerHTML={{ __html: message.message }} 
            />

            {
                message.status === 'error' && (
                    <Button
                        onClick={onRetry}
                        className="btn btn-ghost btn-xs ml-2"
                    >
                        <Icon iconName="RefreshCw" size={12} />
                        Réessayer
                    </Button>
                )
            }
        </div>

        <div className="chat-footer opacity-50 text-xs">
            {new Date(message.date).toLocaleTimeString()}
            {
                message.status === 'error' && (
                    <span className="flex items-center text-error gap-2">
                        <Icon iconName="AlertCircle" size={12} />
                        Erreur d'envoi
                    </span>
                )
            }
        </div>
    </div>
);
